jQuery(document).ready(function ($) {
    if ($().slick) {
        $('.bocss-album').each(function () {
            var currentAlbum = $(this).data('album');
            var shouldAutoplay = $(this).data('autoplay') !== '';
            var autoplaySpeed = parseInt($(this).data('autoplay')) || 0;
            var slideCount = $(this).data('count');
            var $albumSlider = $(this).find('.bocss-album__slider');
            var $navSlider = $(this).find('.bocss-album__navigation');
            var slideWidth = (slideCount * 64) + 30;
            var $this = $(this);

            // Check if the navigation is less than the slider width
            if (slideWidth < $(this).width()) {
                $navSlider.addClass('bocss-album__navigation--static');
            }

            $albumSlider.slick({
                prevArrow: '<button type="button" aria-label="Previous" class="bocss-album__prev"><span class="bocss-album__button bocss-album__button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"/></svg></span></button>',
                nextArrow: '<button type="button" aria-label="Next" class="bocss-album__next"><span class="bocss-album__button bocss-album__button--next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"/></svg></span></button>',
                arrows: true,
                autoplay: shouldAutoplay,
                autoplaySpeed: autoplaySpeed,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 200,
                adaptiveHeight: true,
                asNavFor: '.bocss-album__navigation[data-album=' + currentAlbum + ']'
            });

            $navSlider.slick({
                arrows: false,
                slidesToScroll: 1,
                slidesToShow: slideCount,
                asNavFor: '.bocss-album__slider[data-album=' + currentAlbum + ']',
                focusOnSelect: true,
                variableWidth: true,
                infinite: true,
                speed: 200,
                responsive: [{
                    breakpoint: slideWidth,
                    settings: {
                        infinite: true
                    }
                }]
            });

            $(window).resize(function () {
                if ($(this).width() < slideWidth && $navSlider.hasClass('bocss-album__navigation--static')) {
                    $navSlider.removeClass('bocss-album__navigation--static');
                } else if (slideWidth < $this.width() && !$navSlider.hasClass('bocss-album__navigation--static')) {
                    $navSlider.addClass('bocss-album__navigation--static');
                }
            });
        });
    }
});
